import { createFileRoute } from "@tanstack/react-router"
import { IntegrationsTab } from "./_integrations-tab"

export const Route = createFileRoute("/settings/integrations")({
  component: IntegrationsTab,
})
